export type LearnerApiConfiguration =
  | { readonly mode: "local-only" }
  | { readonly mode: "api"; readonly baseUrl: string };

export interface LearnerApiEnvironment {
  readonly VITE_HISTORY_SIM_API_BASE_URL?: string;
  readonly DEV?: boolean;
}

function isLoopbackHostname(hostname: string): boolean {
  return hostname === "127.0.0.1" || hostname === "::1" || hostname === "localhost";
}

export function resolveLearnerApiConfiguration(
  environment: LearnerApiEnvironment,
): LearnerApiConfiguration {
  const configured = environment.VITE_HISTORY_SIM_API_BASE_URL?.trim();
  if (!configured) return Object.freeze({ mode: "local-only" });

  let parsed: URL;
  try {
    parsed = new URL(configured);
  } catch {
    throw new Error("VITE_HISTORY_SIM_API_BASE_URL must be an absolute HTTP(S) origin");
  }

  const developmentLoopback =
    environment.DEV === true && parsed.protocol === "http:" && isLoopbackHostname(parsed.hostname);
  if (
    (parsed.protocol !== "https:" && !developmentLoopback) ||
    parsed.username !== "" ||
    parsed.password !== "" ||
    parsed.pathname !== "/" ||
    parsed.search !== "" ||
    parsed.hash !== "" ||
    parsed.origin === "null"
  ) {
    throw new Error(
      "VITE_HISTORY_SIM_API_BASE_URL must be an exact HTTPS origin; development permits HTTP loopback only",
    );
  }

  return Object.freeze({ mode: "api", baseUrl: parsed.origin });
}
